<template>
  <div class="memory-form">
    <slot name="header" v-if="!submitted">
      <div class="memory-form__header">
        <span>
          Have You Experienced
          <span style="white-space: nowrap;">East Lake?</span>
        </span>
        <v-btn class="close" @click="close" icon>
          <v-icon color="#e8000b">$close</v-icon>
        </v-btn>
      </div>
    </slot>
    <v-form
      lazy-validation
      v-model="isFormValid"
      ref="form"
      @submit.prevent="submit"
      v-if="!submitted"
    >
      <p>
        You miss East Lake, and we miss having you. But you can still be a part
        of our story! Show off your East Lake pride, tell us about the hidden
        gems, or share the memories that make you can't wait to come back next
        year.
      </p>
      <p>
        Please use the form field below to share your photo and/or text to PGA
        TOUR. Files may not exceed 100mb. We can’t wait to hear your story!
      </p>
      <br />
      <v-textarea
        counter="150"
        maxlength="150"
        v-model="form.description"
        label="Message"
        outlined
        :rules="[validation.required]"
        validate-on-blur
      ></v-textarea>
      <br />
      <Uploader placeholder="Upload photo" v-model="form.source" />

      <hr />

      <div class="page-title">
        Your Info
      </div>
      <br />
      <v-layout :wrap="['xs', 'sm'].includes($size)">
        <v-flex xs12 sm12>
          <v-text-field
            label="First Name"
            v-model="form.first_name"
            :rules="[validation.required]"
            validate-on-blur
          ></v-text-field>
        </v-flex>
        <v-flex class="px-3"></v-flex>
        <v-flex xs12 sm12>
          <v-text-field
            label="Last Name"
            v-model="form.last_name"
            :rules="[validation.required]"
            validate-on-blur
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout :wrap="['xs', 'sm'].includes($size)">
        <v-flex xs12 sm12>
          <v-text-field
            label="Email"
            v-model="form.email"
            :rules="[validation.required, validation.email]"
            validate-on-blur
          ></v-text-field>
        </v-flex>
        <v-flex class="pa-3"></v-flex>
        <v-flex xs12 sm12> </v-flex>
      </v-layout>

      <v-checkbox
        v-model="agree"
        label="By submitting your story, you are agreeing to the possibility that your name, likeness, and words may be publicly posted on this site and/or any other official PGA TOUR Championship social media or digital platforms."
      ></v-checkbox>
      <br />
      <v-btn :disabled="uploading" color="primary" large type="submit">{{
        uploading ? `Uploading... ${progress}` : "Submit"
      }}</v-btn>

      <br />
      <br />
      <Recaptcha />
    </v-form>
    <div v-else class="pa-8 text-center">
      <v-btn class="close" @click="close" icon>
        <v-icon>$close</v-icon>
      </v-btn>
      <div style="max-width: 520px; margin: auto;">
        <div class="h2">Thank you for sharing your story with us!</div>
        <p>
          Your submission will be reviewed and posted live to the site. Please
          share this opportunity with your friends and family using the link
          below.
        </p>
      </div>
      <br />
      <label class="memory-form__copy-link">
        <div class="memory-form__copy-link-field">
          <input type="text" :value="location" ref="copy_input" readonly />
        </div>
        <v-btn class="mr-5" color="primary" @click="copyToClipboard">
          Copy link
        </v-btn>
        <v-btn outlined @click="submitted = false">Share one more</v-btn>
      </label>
    </div>
  </div>
</template>

<script>
import formMixin from "@/mixins/form.mixin";
import { copyToClipboard } from "@/utils";

export default {
  name: "MemoryForm",
  extends: formMixin,
  data() {
    return {
      form: {},
      location: window.location.href,
      agree: true,
      progress: 0,
      uploading: false,
      submitted: false,
    };
  },
  created() {
    this.reset();
  },
  methods: {
    copyToClipboard() {
      this.$refs.copy_input.select();
      copyToClipboard(this.$refs.copy_input.value);
    },
    reset() {
      this.form = {
        first_name: this.currentUser?.first_name || "",
        last_name: this.currentUser?.last_name || "",
        email: this.currentUser?.email || "",
      };
    },
    async submit() {
      this.form.email = this.form.email.trim();
      if (!this.validate()) {
        return this.$alert(
          "Form is invalid, please fill all required fields",
          "error"
        );
      }
      if (!this.agree) {
        return this.$alert(
          "You must agree to the processing of personal data",
          "error"
        );
      }
      try {
        const formData = new FormData();
        this.uploading = true;

        for (const key in this.form) {
          formData.append(`memory[${key}]`, this.form[key]);
        }

        await this.$recaptchaLoaded();
        const recaptcha = await this.$recaptcha("login");
        formData.append("recaptcha", recaptcha);

        await this.$api.Memory.create(formData, {
          onUploadProgress: (progress) => {
            this.progress = progress;
          },
        });
        this.uploading = false;
        this.progress = 0;
        this.reset();
        this.submitted = true;
      } catch {
        this.uploading = false;
        this.progress = 0;
      }
    },
    close() {
      if (!this.uploading) {
        this.reset();
        this.$emit("close");
        this.submitted = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.memory-form {
  position: relative;

  .top-info {
    padding-bottom: 0 !important;

    &,
    &__description {
      text-align: left;
    }
    &__description {
      padding-bottom: 30px;
      border-bottom: 1px solid $primary;
    }
  }
  form,
  .top-info {
    padding: 0 120px;
  }

  &__header {
    color: $primary;
    display: flex;
    align-items: center;
    padding: 0 120px;
    font-size: 50px;
    font-weight: bold;
    padding-top: 80px;
    line-height: 1.2;
    margin-bottom: 15px;
    text-align: center;
  }

  &__tags::v-deep .tags {
    justify-content: normal;
    margin: 0 -5px;
  }

  &__title {
    color: $primary;
    font-weight: bold;
    font-size: 18px;
    margin-right: 15px;
    display: block;
  }

  &__moment-to {
    display: flex;
    align-items: center;

    &__input {
      margin: 0 !important;
      padding: 0 !important;
      height: 34px;
    }
  }
  &__copy-link {
    .v-btn {
      margin: 20px 10px !important;
    }

    &-field {
      border: 1px solid #c4c4c4;
      border-radius: 45px;
      font-family: "Noto Sans";
      font-size: 14px;
      text-align: center;
      color: rgba(0, 0, 0, 0.3);
      display: flex;
      align-items: center;
      padding: 0 20px;
      margin: auto;
      width: 300px;
      height: 36px;

      input {
        outline: none !important;
        width: 300px;
      }
    }
  }
}

@media screen and (max-width: 960px) {
  .memory-form {
    &__header {
      padding: 16px;
      margin-bottom: 0;
      margin-top: 20px;
      font-size: 28px;
    }
    form,
    .top-info {
      padding: 20px;
    }
    .top-info__title {
      font-size: 32px;
      line-height: 35px;
    }

    &__moment-to {
      flex-wrap: wrap;
      &__label {
        width: 100%;
        font-size: 18px;
      }

      &__input {
        margin-top: -10px;
      }
    }

    &__title {
      width: 100%;
    }
  }
}

@media screen and (max-width: 400px) {
  .memory-form__copy-link-field {
    width: unset;
    input {
      width: 100%;
    }
  }
}
</style>
